"use client";

import { services } from "@/app/(site)/data/serviceData";
import ServiceCard1 from "../cards/ServiceCard1";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { revealOnScroll } from "@/lib/animations/gsap";
import { useEffect } from "react";

export default function ServicesSection() {

    useEffect(() => {
        revealOnScroll(".service-card", {
            y: 80,
            duration: 0.9,
            delayBetween: 0.5, // delay between each card
            start: "top 85%",
        });
    }, []);

    return (
        <div className="flex flex-col w-full items-start justify-start py-22 gap-14 px-5 md:px-20 mx-auto">

            {/* top section */}
            <div className="flex md:flex-row flex-col w-full items-start justify-start gap-5 md:gap-0 md:justify-between">
                <h3 className="text-[42px] font-lora font-bold leading-8">Explore our solutions</h3>
                <p className="md:w-[50%] text-lg md:text-justify md:px-14">
                    We provide tailored legal strategies grounded in deep industry insight and proven experience, helping you navigate complex challenges with clarity, confidence, and precision
                </p>
                <Link href="/expertise" className="flex items-center gap-4 bg-secondary text-[18px] py-3 px-4 text-primary hover:bg-secondary/80 transition">
                    Explore all <ArrowRight />
                </Link>
                
            </div>

            {/* middle scroll section - services */}
            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-10 lg:gap-12">
                {services.slice(0, 6).map((service) => (
                    <div key={service.number} className="service-card w-full">
                        <ServiceCard1 service={service} />
                    </div>
                ))}
            </div>
        </div>
    );
}